import exampleCreativesTpl from '../templates/creatives/example_creatives.directive.html';

function ExampleCreativesController(
  CurrentUserService,
  CreativeService,
  ExamplesService,
  SettingsService
) {
  const vm = this;

  vm.creativeService = CreativeService;
  vm.examplesService = ExamplesService;
  vm.settingsService = SettingsService;
  vm.setCreative = setCreative;

  CurrentUserService.get().then(user => {
    vm.currentUser = user;
  });

  function setCreative(event, example) {
    if (event.target.matches('.ad-options-button')) {
      return;
    }
    vm.creativeService.setCreative(example.creative);
  }

  ExamplesService.getExamples();
}

ExampleCreativesController.$inject = [
  'CurrentUserService',
  'CreativeService',
  'ExamplesService',
  'SettingsService'
];

export default function exampleCreatives() {
  return {
    template: exampleCreativesTpl,
    controller: ExampleCreativesController,
    controllerAs: 'exampleCreativesVm'
  };
}
